/* Program Name: SupportDialog.js
 **  Description: a modal for displaying the support and help information for users
 **
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-05-14  STT  Initial program
 ** SD6391     2024-12-23  sgs  Support - Allow file upload on links
 *********************************************************************************/

/**React imports */
import React, { useEffect, useRef, useState } from 'react'

/**Custom Component imports */
import Window from '../Window'

/** API imports */
import { getSupport } from '../../../API/generalAPI'
import { ezpopURL } from '../ezpopURL'

/** Context imports */
import { useAlert } from '../../../Context/AlertContext'
import { FlexBox } from '../CustomDivs'
import { useLoading } from '../../../Context/LoadingContext'

/**SupportDialog ***************************************************************/
//open  => bool => boolean that determines if the modal is open
//close => func => function that sets open to false
const SupportDialog = ({ open, close }) => {
  /****************************************************************************/
  /**Local Variables */

  const alert = useRef(useAlert())

  const loading = useRef(useLoading())

  const [supportLinks, setSupportLinks] = useState([])

  /****************************************************************************/
  /**Use Effect */
  useEffect(() => {
    if (open) {
      loading.current.startLoading()
      getSupport()
        .then((response) => {
          if (response.data.meta[0].err) {
            alert.current.postAjaxAlert(response.data.meta[0])
          } else {
            if (response.data.ttLinkGroup) {
              setSupportLinks(response.data.ttLinkGroup)
            } else {
              setSupportLinks([])
            }
          }
        })
        .catch((error) => {
          alert.current.errorMessage(error.message)
        })
        .then(() => {
          loading.current.stopLoading()
        })
    }
  }, [open])

  return (
    <Window
      width={'md'}
      open={open}
      close={() => {
        close(false)
      }}
      title={'Support'}
    >
      <div>
        {supportLinks.map((group, i) => {
          return (
            <div key={i}>
              <h3>{group.dispText}</h3>
              {group.ttLink &&
                group.ttLink.map((link, index) => {
                  return (
                    <FlexBox key={`child-${index}`}>
                      <div>{link.dispText}</div>
                      {link.allowFileUpload && (
                        <a
                          style={{ paddingLeft: '16px' }}
                          href={`${ezpopURL}${link.webPath}${link.filePath?link.filePath:''}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {link.linkText}
                        </a>
                      )}
                      {!link.allowFileUpload && (
                        <a
                          style={{ paddingLeft: '16px' }}
                          href={link.href?link.href:''}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {link.linkText}
                        </a>
                      )}
                    </FlexBox>
                  )
                })}
            </div>
          )
        })}
      </div>
    </Window>
  )
}

export default SupportDialog
